/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {firstValueFrom, tap} from 'rxjs';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../../routing/state-utils';
import {SignalAdminResourcePageState} from '../../common/controller/signal-admin-resource-page-state';
import {SignalAdminResourceTitleComponent} from '../../common/controller/signal-admin-resource-title.component';
import {CreativeApiService} from '../../creative/creative-api.service';
import {PERMISSIONS} from '../../../components/auth/auth-constants';
import {UserProfileSaverService} from '../../../components/session/user-profile-saver.service';
import {LayoutListPageComponent} from './layout-list-page.component';
import {LayoutApiService, LayoutModel} from './layout-api.service';
import {LayoutEditPageComponent} from './layout-edit-page.component';
import {LayoutContextRoutePageComponent} from './layout-context-route-page.component';
import {LayoutCopyModalComponent} from './layout-copy-modal.component';


export function layoutStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
const api = adnRouterHelper.services.service(LayoutApiService);
const permissions = adnRouterHelper.services.localUserPermissions();
const userProfileSaver = adnRouterHelper.services.service(UserProfileSaverService);
const readOnly = () => !permissions.hasNetwork(PERMISSIONS.manageLayouts.apiKey)
  && !permissions.hasNetwork(PERMISSIONS.axPublisherAdmin.apiKey);
const rh = adnRouterHelper.createRouterAndChildHelper('layouts.layout', LayoutApiService, CreativeApiService, 'app.adm', 'app/admin');
const copyConfig = {
  modalComponent: LayoutCopyModalComponent,
  stateUrl: 'app.adm.layouts.layout',
  lcase: 'layout',
  ucase: 'Layout'
};
    
        states.add(rh.listPath(), rh.list({
          views: {
            'content@app': {component: LayoutListPageComponent, bindings: {readOnly: 'readOnly'}}
          },
          resolve: {readOnly}
        }));
    
        states.add(rh.newItemPath(), rh.newItem());
    
        states.add(rh.itemPath(), rh.item({
          resolve: {
            layoutPage: function($stateParams: any) {
              if ($stateParams.isNew) {
                const model: LayoutModel = {id: $stateParams.id, objectState: 'ACTIVE', validationWarnings: []};
                return new SignalAdminResourcePageState(model, true, readOnly(), api, 'Layout', 'name', copyConfig);
              }
              return firstValueFrom(api.get($stateParams.id).pipe(
                tap((model) => userProfileSaver.saveObj(model, 'adnLastViewed'))
              )).then((model) => new SignalAdminResourcePageState(
                model, false, readOnly(), api, 'Layout', 'name', copyConfig
              ));
            },
            model: (layoutPage: SignalAdminResourcePageState<LayoutModel>) => layoutPage.model()
          },
            views: {
            'content@app': {component: LayoutEditPageComponent, bindings: {state: 'layoutPage'}},
            'context@app': {component: LayoutContextRoutePageComponent, bindings: {state: 'layoutPage'}},
            'title@app': {component: SignalAdminResourceTitleComponent, bindings: {state: 'layoutPage'}}
            }
        }));
  return states.build();
}
